import * as y from "yup"

export const hideIf = ["viewed", "clicked", "dismissed"] as const
export const contentCardIds = ["popup", "banner", "trigger", "message"] as const

export type ContentCardID = (typeof contentCardIds)[number]

export const idSchema = y.mixed().oneOf(mutable(contentCardIds))

/**
 * Implemented by all Content Cards
 * the properties are available to all braze content cards
 */
export interface ComponentBase {
  id: string
  hideIf?: (typeof hideIf)[number]
}

export const baseSchema = {
  id: y.string().required(),
  hideIf: y.mixed().oneOf(mutable(hideIf))
} as const

/**
 * Convert a readonly array or object to a mutable one
 *
 * Main intention at this point is to pass constant arrays to yup schemas
 */
export function mutable<T>(t: T) {
  if (Object.isFrozen(t)) {
    console.error(t)
    throw new Error(`trying to make immutable object mutable`)
  }
  return t as DeepWriteable<T>
}
